var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0zm2 0c0 5.523-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0s10 4.477 10 10zM8.792 11.124v.49h1.752v-.395c0-.18.023-.335.068-.461a1.06 1.06 0 0 1 .299-.394c.145-.136.348-.303.61-.503.354-.262.648-.507.884-.733a2.46 2.46 0 0 0 .53-.76c.117-.272.176-.593.176-.964 0-.698-.263-1.272-.788-1.725C11.807 5.226 11.078 5 10.137 5a5.92 5.92 0 0 0-1.698.23A7.288 7.288 0 0 0 7 5.829l.72 1.453c.389-.199.77-.357 1.14-.475a3.709 3.709 0 0 1 1.127-.176c.38 0 .675.076.883.23.217.145.326.362.326.652 0 .29-.09.543-.272.76-.172.209-.461.458-.869.747-.461.335-.787.657-.977.965-.19.307-.286.688-.286 1.14zm.123 1.888c-.227.163-.34.452-.34.869 0 .398.113.688.34.869.226.172.502.258.828.258.317 0 .588-.086.815-.258.226-.181.34-.47.34-.87 0-.416-.114-.705-.34-.868a1.307 1.307 0 0 0-.815-.258c-.326 0-.602.086-.828.258z",
    fill: "#111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.7b9795e2204c6f714363e7359d9cf817.svg";
export { ForwardRef as ReactComponent };